import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import OrdersPage from "./components/Client Components/OrdersPage"; // Orders Page Component
import SalesOrdersPage from "./components/Sales Executive/Order Create/SalesOrdersPage";
import Login from "./components/Authentication/Login";
import ClientPage from "./components/Sales Executive/Create Client/ClientPage";
import CategoriesPage from "./components/Sales Executive/Items Master/CategoriesPage";
import Hero from "./components/Hero";
import PrivateRoute from "./PrivateRoute"; // Import the PrivateRoute component

import UserPage from "./components/Authentication/UserPage";
import ResetPasswordPage from "./components/Authentication/ResetPasswordPage";
import PurchaseOrderForm from "./components/Sales Executive/Purchase Order/PurchaseOrderForm";
import PurchaseOrdersTable from "./components/Sales Executive/Purchase Order/PurchaseOrdersTable";
import MaterialInwardRegister from "./components/Sales Executive/Purchase Order/MaterialInwardRegister";
import ViewPurchaseOrder from "./components/Sales Executive/Purchase Order/ViewPurchaseOrder";
import Layout from "./components/Layout/Layout.jsx";
import AdminLayout from "./components/Layout/AdminLayout.jsx";

import SuppliersTable from "./components/Admin/Supplier/SuppliersTable";
import WarehouseInventoryTable from "./components/Admin/Warehouse/WarehouseInventoryTable";
import OrderStatusTable from "./components/Sales Executive/Order Create/OrderStatusTable";
import OrderDetailsPage from "./components/Sales Executive/Order Create/OrderDetailsPage";
import PaymentSection from "./components/Client Payment Section/PaymentSection";
import ClientDashboard from "./components/Sales Executive/Others/ClientDashboard";
import HeroSection from "./components/HomePage/Hero";
import PaymentTable from "./components/Client Payment Section/PaymentTable";
import ClientDashboardPayment from "./components/Client Components/ClientDashboardPayment";
import Dashboard from "./components/Admin/DashBoard/Dashboard";
import LocalPurchaseOrdersTable from "./components/Sales Executive/Purchase Order/LocalPurchaseOrdersTable";
import TransferHistoryTable from "./components/Admin/Warehouse/TransferHistoryTable";
import ClientLayout from "./components/Layout/ClientLayout";

import Home from "./components/Sales Executive/Purchase Order/LocalPurchaseOrderPdf/Page";
import PaymentSectionWholeClient from "./components/Client Payment Section/PaymentSectionWholeClient";
import SalesExecutiveReport from "./components/Admin/DashBoard/SalesExecutiveReport";
import SalesReport from "./components/Admin/DashBoard/SalesReport";
import ClientItemMaster from "./components/Client Components/ClientItemMaster";

function App() {
  return (
    <div className="App">
      <Router>
        {/* Define routes for different pages */}
        <Routes>
          {/* Home Route */}
          <Route path="/" element={<HeroSection />} />

          {/* Login Route */}
          <Route path="/login" element={<Login />} />
          <Route
            path="/reset-password/:resetToken"
            element={<ResetPasswordPage />}
          />

          {/* Orders Page Route (client role only) */}
          <Route
            path="/orders"
            element={
              <PrivateRoute
                allowedRoles={["client"]}
                element={<OrdersPage />}
              />
            }
          />

          <Route
            path="/admin/users"
            element={
              <PrivateRoute allowedRoles={["admin"]} element={<UserPage />} />
            }
          />

          <Route
            path="/admin/*"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                element={<AdminLayout />}
              />
            }
          >
            <Route path="supplier" element={<SuppliersTable />} />
            <Route path="dashboard" element={<Dashboard />} />

            <Route
              path="warehouse-inventory"
              element={<WarehouseInventoryTable />}
            />
            <Route
              path="warehouse-inventory/transferhistory"
              element={<TransferHistoryTable />}
            />

            <Route
              path="client/payment/:clientId"
              element={<PaymentSection />}
            />
            <Route
              path="client/payment"
              element={<PaymentSectionWholeClient />}
            />

            <Route
              path="order/client/clientDetails/:clientId"
              element={<ClientDashboard />}
            />
            <Route path="purchaseOrder" element={<PurchaseOrderForm />} />
            <Route
              path="purchaseOrder-details"
              element={<PurchaseOrdersTable />}
            />
            <Route
              path="material-inward/:grnId"
              element={<MaterialInwardRegister />}
            />

            <Route path="order/status-details" element={<OrderStatusTable />} />
            <Route path="order/:orderId" element={<OrderDetailsPage />} />
            <Route path="client/payment/details" element={<PaymentTable />} />
            <Route
              path="purchaseOrder/localpurchaseorder"
              element={<LocalPurchaseOrdersTable />}
            />
            <Route
              path="sales-executive/report"
              element={<SalesExecutiveReport />}
            />
            <Route path="sales-report" element={<SalesReport />} />
          </Route>

          <Route
            path="/sales-executive/*"
            element={
              <PrivateRoute
                allowedRoles={["sales executive"]}
                element={<Layout />}
              />
            }
          >
            <Route path="purchaseOrder" element={<PurchaseOrderForm />} />
            <Route
              path="purchaseOrder-details"
              element={<PurchaseOrdersTable />}
            />
            <Route
              path="material-inward/:grnId"
              element={<MaterialInwardRegister />}
            />

            <Route
              path="warehouse-inventory"
              element={<WarehouseInventoryTable />}
            />
            <Route path="order/status-details" element={<OrderStatusTable />} />
            <Route path="order/:orderId" element={<OrderDetailsPage />} />
            <Route
              path="purchaseOrder/localpurchaseorder"
              element={<LocalPurchaseOrdersTable />}
            />
            <Route path="sales-report" element={<SalesReport />} />
          </Route>
          <Route
            path="/purchaseOrder/localpurchaseorder/:purchaseId"
            element={
              <PrivateRoute
                allowedRoles={["admin", "sales executive", "client"]}
                element={<Home />}
              />
            }
          />
          <Route
            path="/client/*"
            element={
              <PrivateRoute
                allowedRoles={["client"]}
                element={<ClientLayout />}
              />
            }
          >
            <Route
              path="paymentdashboard"
              element={<ClientDashboardPayment />}
            />
            <Route
              path="purchaseOrder/localpurchaseorder"
              element={<LocalPurchaseOrdersTable />}
            />
            <Route path="items-master" element={<ClientItemMaster />} />
          </Route>
          <Route
            path="/finance/*"
            element={
              <PrivateRoute
                allowedRoles={["finance"]}
                element={<AdminLayout />}
              />
            }
          >
            <Route path="client/payment/details" element={<PaymentTable />} />
            <Route
              path="client/payment/:clientId"
              element={<PaymentSection />}
            />
          </Route>

          {/* Sales Orders Page Route (sales executive role only) */}
          <Route
            path="/sales-executive/order"
            element={
              <PrivateRoute
                allowedRoles={["sales executive"]}
                element={<SalesOrdersPage />}
              />
            }
          />
          <Route
            path="/admin/order"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                element={<SalesOrdersPage />}
              />
            }
          />

          {/* Client Management Route (sales executive role only) */}
          <Route
            path="/sales-executive/clients"
            element={
              <PrivateRoute
                allowedRoles={["sales executive"]}
                element={<ClientPage />}
              />
            }
          />
          <Route
            path="/admin/clients"
            element={
              <PrivateRoute allowedRoles={["admin"]} element={<ClientPage />} />
            }
          />

          {/* Categories Management Route (sales executive role only) */}
          <Route
            path="/sales-executive/items-master"
            element={
              <PrivateRoute
                allowedRoles={["sales executive"]}
                element={<CategoriesPage />}
              />
            }
          />
          <Route
            path="/admin/items-master"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                element={<CategoriesPage />}
              />
            }
          />

          {/* You can add more protected routes here */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;